import './types';

/** Запущены ли мы как Telegram Mini App ПРЯМО СЕЙЧАС (initData уже наполнен) — синхронная проверка. */
export function isTelegram(): boolean {
  return typeof window !== 'undefined' && !!window.Telegram?.WebApp?.initData;
}

/** Присутствует ли Telegram WebApp SDK (объект есть, даже если initData ещё не наполнен). */
export function hasTelegramWebApp(): boolean {
  return typeof window !== 'undefined' && !!window.Telegram?.WebApp;
}

/**
 * Ждёт непустой initData. При холодном запуске Telegram наполняет его НЕ мгновенно
 * (скрипт telegram-web-app.js с telegram.org + инъекция данных приходят с задержкой,
 * особенно в РФ) — поэтому одиночная проверка на маунте часто промахивается и юзер
 * проваливается на экран входа. Опрашиваем до timeoutMs и возвращаем initData, как
 * только он появится; иначе null. Если SDK вообще нет — сразу null (это не Telegram).
 */
export function waitForTelegramInitData(timeoutMs = 3000, intervalMs = 60): Promise<string | null> {
  const webApp = () => (typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined);
  return new Promise((resolve) => {
    if (!webApp()) {
      resolve(null);
      return;
    }
    const immediate = webApp()?.initData ?? '';
    if (immediate) {
      resolve(immediate);
      return;
    }
    const start = Date.now();
    const timer = setInterval(() => {
      const data = webApp()?.initData ?? '';
      if (data) {
        clearInterval(timer);
        resolve(data);
      } else if (Date.now() - start >= timeoutMs) {
        clearInterval(timer);
        resolve(null);
      }
    }, intervalMs);
  });
}
